import { render, staticRenderFns } from "./CollapseOfTheProductFilter.vue?vue&type=template&id=d27f266c"
import script from "./CollapseOfTheProductFilter.vue?vue&type=script&lang=js"
export * from "./CollapseOfTheProductFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports